/**
 * ログインすると使える機能の訴求。
 *
 * スプリは会員登録なしでも全機能が使える方針なので、
 * 「できません」ではなく「ログインすると、これができます」と伝える。
 */
import { Link } from "react-router-dom";
import { Icon, type IconName } from "./Icon.js";

export interface LoginUpsellProps {
  icon: IconName;
  title: string;
  description: string;
}

export function LoginUpsell({ icon, title, description }: LoginUpsellProps) {
  return (
    <div className="upsell">
      <span className="upsell__icon">
        <Icon name={icon} />
      </span>
      <span className="upsell__body">
        <strong className="upsell__title">{title}</strong>
        {description}
      </span>
      <Link className="button button--small" to="/login">
        ログイン
      </Link>
    </div>
  );
}
